import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import api from '../../config/api'
import {
    clearStoredUser,
    getStoredUser,
    getUserDisplayName,
    persistAuth,
} from '../../config/authUtils'

const Lockscreen = () => {
    const navigate = useNavigate()
    const user = getStoredUser()
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (!getStoredUser()) {
            navigate('/login', { replace: true })
        }
    }, [navigate])

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!user?.email) {
            navigate('/login', { replace: true })
            return
        }

        setLoading(true)
        setError(null)

        try {
            const response = await api.post('/auth/login/', {
                email: user.email,
                password,
            })
            persistAuth(response.data)
            navigate('/', { replace: true })
        } catch (err) {
            console.error('Unlock failed', err)
            setError(
                err.response?.data?.detail ||
                err.response?.data?.message ||
                'Incorrect password. Please try again.'
            )
        } finally {
            setLoading(false)
        }
    }

    const handleSwitchAccount = () => {
        clearStoredUser()
        navigate('/login', { replace: true })
    }

    if (!user) {
        return null
    }

    return (
        <div className="main-wrapper auth-bg position-relative overflow-hidden">
            <div className="container-fluid position-relative z-1">
                <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
                    <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
                        <div className="col-lg-4 mx-auto">
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="d-flex flex-column justify-content-lg-center p-4 p-lg-0 pb-0 flex-fill">
                                    <div className="mx-auto mb-5 text-center">
                                        <img src="/assets/img/media/burray.png" className="img-fluid" width="100" alt="Logo" />
                                    </div>

                                    <div className="card border-1 p-lg-3 shadow-md rounded-3">
                                        <div className="card-body">
                                            <div className="text-center mb-3">
                                                <h5 className="mb-1 fs-20 fw-bold">Welcome Back!</h5>
                                                <p className="text-muted mb-0">Enter your password to continue</p>
                                            </div>

                                            <div className="text-center mb-3">
                                                <span className="avatar avatar-xxxl rounded-circle flex-shrink-0">
                                                    <img src="/assets/img/avatar101.jpg" className="rounded-circle" alt="" />
                                                </span>
                                                <h6 className="text-dark mt-2 mb-0">{getUserDisplayName(user)}</h6>
                                                <p className="text-muted fs-13 mb-0">{user.email}</p>
                                            </div>

                                            <form onSubmit={handleSubmit} noValidate>
                                                {error && (
                                                    <div className="alert alert-danger py-2 mb-3" role="alert">
                                                        <i className="ti ti-alert-circle me-2" />
                                                        {error}
                                                    </div>
                                                )}

                                                <div className="mb-3">
                                                    <label htmlFor="lockscreen-password" className="form-label">Password</label>
                                                    <div className="input-group input-group-flat">
                                                        <span className="input-group-text">
                                                            <i className="ti ti-lock-open fs-14 text-dark" />
                                                        </span>
                                                        <input
                                                            id="lockscreen-password"
                                                            type={showPassword ? 'text' : 'password'}
                                                            className="pass-input form-control ps-1"
                                                            placeholder="************"
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            required
                                                            autoComplete="current-password"
                                                            autoFocus
                                                        />
                                                        <span
                                                            className={`input-group-text ti ${showPassword ? 'ti-eye' : 'ti-eye-off'} fs-14 text-dark`}
                                                            role="button"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setShowPassword((prev) => !prev)}
                                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                                                        {loading ? <BeatLoader color="#fff" size={8} /> : 'Unlock'}
                                                    </button>
                                                </div>

                                                <div className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link text-decoration-none p-0"
                                                        onClick={handleSwitchAccount}
                                                    >
                                                        Sign in as a different user
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    <p className="text-center mt-3 mb-0">
                                        <Link to="/login" className="text-muted fs-13">Back to login</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Lockscreen

